<!-- src/views/teacher/TeacherDashboard/DivWrapperScreen/DivWrapperScreen.vue -->
<template>
	<div class="div-wrapper-screen">
		<HeaderSubsection />
		
		<main class="main-content">
			<!--  Центрирующий контейнер для приветствия -->
			<div class="welcome-section">
				<h1 class="welcome-title">Здравствуйте, {{ userName }}!</h1>
			</div>
			
			<!--  DivSubsection эмитит конференции с цветами -->
			<DivSubsection @conferences-loaded="onConferencesLoaded" />
			
			<!--  FrameSubsection получает их через props -->
			<FrameSubsection :conferences-with-colors="conferencesForCalendar" />
			
			<DivWrapperSubsection />
			<ViewWrapperSubsection />
		</main>
	</div>
</template>

<script>
import { useAppStore } from '@/stores/useAppStore'
import ViewSubsection from './sections/ViewSubsection.vue'
import ViewWrapperSubsection from './sections/ViewWrapperSubsection.vue'
import DivWrapperSubsection from './sections/DivWrapperSubsection.vue'
import FrameSubsection from './sections/FrameSubsection.vue'
import HeaderSubsection from './sections/HeaderSubsection.vue'
import DivSubsection from './sections/DivSubsection.vue'

export default {
	name: 'DivWrapperScreen',
	
	components: {
		ViewSubsection,
		ViewWrapperSubsection,
		DivWrapperSubsection,
		FrameSubsection,
		HeaderSubsection,
		DivSubsection,
	},

	setup() {
		const appStore = useAppStore()
		return { appStore }
	},

	data() {
		return {
			conferencesForCalendar: []
		}
	},

	computed: {
		userName() {
			const user = this.appStore.currentUser
			if (!user) return 'Пользователь'
			
			const fullName = user.fullName || user.full_name || ''
			const parts = fullName.trim().split(/\s+/)
			
			// Если формат "Фамилия Имя [Отчество]" — берём второе слово (имя)
			// Если только одно слово — используем его
			const firstName = parts.length > 1 ? parts[1] : parts[0]
			
			return firstName || user.email?.split('@')[0] || 'Пользователь'
		}
	},

	methods: {
		onConferencesLoaded(conferences) {
			console.log('📅 Conferences loaded for calendar:', conferences?.length || 0)
			this.conferencesForCalendar = conferences || []
		}
	}
}
</script>

<style scoped>
.div-wrapper-screen {
	background-color: #F9F9F980;
	min-height: 100vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
	overflow-y: auto;
	overflow-anchor: none;
	scrollbar-gutter: stable;
}

.main-content {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 40px;
	padding-bottom: 60px;
}

/*  Центрированное приветствие */
.welcome-section {
	width: 100%;
	padding: 48px 24px 20px;
	text-align: center;
}

.welcome-title {
	color: #252641;
	font-family: 'Poppins', Helvetica;
	font-size: 32px;
	font-weight: 600;
	margin: 0;
}

@media (max-width: 768px) {
	.welcome-section {
		padding: 32px 16px 16px;
	}

	.welcome-title {
		font-size: 26px;
	}

	.main-content {
		gap: 30px;
	}
}
</style>
